export const LOCATION = {
  SET_LOCATION: 'SET_LOCATION'
}
